import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import Button from '../Button';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/Check';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './ProfileOwnerWatchButton.scss';
import sV2 from './ProfileOwnerWatchButtonV2.scss';
var ProfileOwnerWatchButton = function (_a) {
    var _b;
    var disabled = _a.disabled, _c = _a.height, height = _c === void 0 ? 'medium' : _c, className = _a.className, view = _a.view, disableClickHandler = _a.disableClickHandler, user = _a.user, initialData = _a.initialData, onClickProp = _a.onClick, _d = _a.useV2Styles, useV2Styles = _d === void 0 ? true : _d, isFakeButton = _a.isFakeButton, fullWidth = _a.fullWidth, renderCustomText = _a.renderCustomText, onToggleWatchSuccess = _a.onToggleWatchSuccess;
    var _e = useWatchButton(user, (_b = user.isWatching) !== null && _b !== void 0 ? _b : initialData === null || initialData === void 0 ? void 0 : initialData.isWatching, false, disabled, onToggleWatchSuccess), text = _e.text, isWatching = _e.isWatching, isLoading = _e.isLoading, biData = _e.biData, onClick = _e.onClick;
    var _f = useState(false), isNewWatching = _f[0], setIsNewWatching = _f[1];
    var defaultWatchigState = !isLoading && isWatching;
    var loadingWatchingState = isLoading && !isWatching;
    var loadingUnwatchingState = isLoading && isWatching;
    var handleClick = useCallback(function (e) {
        if (disableClickHandler) {
            return;
        }
        setIsNewWatching(!isWatching);
        onClick();
        onClickProp && onClickProp(e);
    }, [disableClickHandler, isWatching, onClick, onClickProp]);
    var handleMouseLeave = useCallback(function (e) {
        // when you click on button's child elements,
        // the mouseleave event triggers
        if (e.currentTarget !== e.target) {
            return;
        }
        setIsNewWatching(false);
    }, []);
    var styles = useV2Styles ? sV2 : s;
    return (React.createElement(Button, { view: view ? view : 'b1', biData: biData, height: height, className: classnames(styles['root'], defaultWatchigState && !isNewWatching && styles['watch-btn-unwatch'], defaultWatchigState && styles['watch-btn-watching'], loadingUnwatchingState && styles['watch-btn-loading-unwatch'], loadingWatchingState && styles['watch-btn-loading'], className), onClick: handleClick, onMouseLeave: handleMouseLeave, disabled: disabled, dataHook: BiDataHook.USER_WATCH_BUTTON, isFakeButton: isFakeButton, fullWidth: fullWidth },
        React.createElement(Plus, { customSizable: true, disableDefaultColors: true, className: styles['plus-icon'], size: IconSize.SMALL }),
        isWatching && !isLoading && (React.createElement(Check, { customSizable: true, disableDefaultColors: true, className: styles['check-icon'], size: IconSize.SMALL })),
        React.createElement("span", { className: classnames((defaultWatchigState || loadingWatchingState) &&
                styles['watch-btn-text']) }, renderCustomText ? renderCustomText(isWatching) : text)));
};
ProfileOwnerWatchButton.displayName = 'ProfileOwnerWatchButton';
export default ProfileOwnerWatchButton;
//# sourceMappingURL=ProfileOwnerWatchButton.js.map